import * as React from 'react';
import { RouteComponentProps, Switch, withRouter } from 'react-router';
import * as _ from 'underscore';

import { LoginUrlsWrapper } from '../Login/LoginUrls';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface TableauReactRouterSwitchOwnProps {
  readonly basePaths: string[];
  readonly urls: SpacesSiteUrls;
}

export type TableauReactRouterSwitchProps = TableauReactRouterSwitchOwnProps & RouteComponentProps;

export class TableauReactRouterSwitchComponent extends React.Component<TableauReactRouterSwitchProps> {
  public render() {
    return (
      <Switch>
        {this.props.children}
      </Switch>
    );
  }

  public shouldComponentUpdate(nextProps: TableauReactRouterSwitchProps): boolean {
    return doBasePathsIncludeNextPath(nextProps, this.props.basePaths, this.props.urls);
  }
}

// exported for testing
export function doBasePathsIncludeNextPath(nextProps: TableauReactRouterSwitchProps, basePaths: string[], urls: SpacesSiteUrls) {
  // This bit of logic is required because of the two-router solution we have in VPC.
  // The user clicks to redirect away from the react router Switch.
  // The new url won't match any of the routes underneath the switch so it displays the error.
  // We are still within this switch because angular ui-state hasn't updated yet.
  // Once that angular ui-state updates it will navigate away to the new state.
  // This causes a quick flash of the error page as user navigates away.
  // Not updating when the url doesn't start with the HashRouter baseUrl prevents this flash.
  return _.some(basePaths, (baseUrl) => {
    // TFSID:953561 so that login /site does works properly with /site/stuff
    if (baseUrl === LoginUrlsWrapper.getInstance().sitePath()) {
      return nextProps.location.pathname === baseUrl;
    }

    // TFSID:955336 - should be removed when the viz page uses react router (vizRR)
    // /views (Site space) is a react-routerified page /views/someWB/someViewName (viz page) is _not_
    // so we only want to match and check our react router switch for /views and not for the viz page
    // we need to check that urls exist because they are undefined when just starting the app
    if (urls && baseUrl === urls.viewsPath()) {
      return nextProps.location.pathname === baseUrl;
    }

    // TFSID:903079 remove this when flows react router is done!!
    if (urls && baseUrl === urls.flowsPath()) {
      return nextProps.location.pathname === baseUrl;
    }
    return nextProps.location.pathname.startsWith(baseUrl);
  });
}

export const TableauReactRouterSwitch: React.ComponentType<TableauReactRouterSwitchOwnProps> = withRouter(TableauReactRouterSwitchComponent);
